import { DOCUMENT, inject, Injectable } from "@angular/core";
import { SessionService } from "@kno2/core/session";
import { DialogService } from "@kno2/shared/dialog";
import { minutesToMilliseconds, secondsToMilliseconds } from "date-fns";
import { SessionTimeoutComponent } from "./session-timeout.component";

@Injectable({
    providedIn: "root"
})
export class SessionTimeoutService {
    private readonly document = inject(DOCUMENT);
    private readonly dialogService = inject(DialogService);
    private readonly sessionService = inject(SessionService);

    private timeout = 10;
    private promptAt: number;
    private isOpen = false;
    private started = false;

    public start(): void {
        if (this.started) return;
        this.started = true;

        const minutes = this.sessionService.profileData()?.sessionTimeoutMinutes;
        if (minutes) this.timeout = minutes;

        this.document.addEventListener("click", () => this.resetDeadline());
        this.document.addEventListener("keydown", () => this.resetDeadline());
        this.resetDeadline();
        setInterval(() => void this.checkDeadline(), 1000);
    }

    private resetDeadline(): void {
        if (this.isOpen) return;

        this.promptAt = Date.now() + minutesToMilliseconds(this.timeout - 1) + secondsToMilliseconds(5);
    }

    private async checkDeadline(): Promise<void> {
        if (this.isOpen || Date.now() < this.promptAt) return;

        this.isOpen = true;
        await this.dialogService.open(SessionTimeoutComponent, {
            headerText: "Warning",
            width: "800px",
            closable: false,
            closeOnEscape: false
        });
        this.isOpen = false;
        this.resetDeadline();
    }
}
